var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dateNumb.length > 0)?_c('div',{staticClass:"time-count"},[_c('div',[_vm._v(_vm._s(_vm.dateNumb[0])+_vm._s(_vm.dateNumb[1]))]),_c('div',[_vm._v(_vm._s(_vm.dateNumb[2])+_vm._s(_vm.dateNumb[3]))]),_c('div',[_vm._v(_vm._s(_vm.dateNumb[4])+_vm._s(_vm.dateNumb[5]))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }